import { createSignal } from "solid-js"
import type { TileGraphNode } from "../../lib/core/engine/TileGraphNode/TileGraphNode.type"
import { immutableEmptyArray } from "../../lib/lib"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useTileNodeListSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Array<TileGraphNode>>(immutableEmptyArray as unknown as Array<TileGraphNode>)

  return signal
})


